import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import { ReportFormWidget } from '../widgets/report-form-widget';

class ManagerReportForm {
  private reportFormWidget: ReportFormWidget;

  constructor() {
    this.reportFormWidget = new ReportFormWidget();
  }

  public init(): void {
    if (
      location.pathname.includes('/lk/manager/reports') ||
      location.pathname.includes('/manager-report-form')
    ) {
      this.reportFormWidget.init();
      this.bindEvents();
    }
  }

  private bindEvents(): void {}
}

registerPageInit('manager-report-form', () => {
  const page = new ManagerReportForm();
  page.init();
});
